var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Firebase from '@constants/firebase';
var firebaseConfig = null;
var clientPromise = null;
export function setFirebaseConfig(config) {
    firebaseConfig = config;
    clientPromise = null;
}
export function initFirebaseClient() {
    if (!clientPromise) {
        clientPromise = createFirebaseClient().catch(function () { return null; });
    }
    return clientPromise;
}
export function reportError(payload) {
    void initFirebaseClient().then(function (client) { return client === null || client === void 0 ? void 0 : client.trackError(payload); });
}
function createFirebaseClient() {
    return __awaiter(this, void 0, void 0, function () {
        var config, _a, _b, initializeApp, getApp, getApps, analyticsModule, app, analytics;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!firebaseConfig)
                        return [2 /*return*/, null];
                    config = firebaseConfig;
                    return [4 /*yield*/, Promise.all([
                            import('firebase/app'),
                            import('firebase/analytics')
                        ])];
                case 1:
                    _a = _c.sent(), _b = _a[0], initializeApp = _b.initializeApp, getApp = _b.getApp, getApps = _b.getApps, analyticsModule = _a[1];
                    app = getApps().length ? getApp() : initializeApp(config);
                    return [4 /*yield*/, initAnalytics(app, analyticsModule)];
                case 2:
                    analytics = _c.sent();
                    return [2 /*return*/, {
                            trackError: function (payload) {
                                if (!analytics)
                                    return;
                                analyticsModule.logEvent(analytics, Firebase.UI_ERROR_EVENT, payload);
                            }
                        }];
            }
        });
    });
}
function initAnalytics(app, analyticsModule) {
    return __awaiter(this, void 0, void 0, function () {
        var initializeAnalytics, getAnalytics, isSupported;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    initializeAnalytics = analyticsModule.initializeAnalytics, getAnalytics = analyticsModule.getAnalytics, isSupported = analyticsModule.isSupported;
                    return [4 /*yield*/, isSupported()];
                case 1:
                    if (!(_a.sent()))
                        return [2 /*return*/, null];
                    try {
                        return [2 /*return*/, initializeAnalytics(app, {
                                config: { send_page_view: Firebase.SEND_PAGE_VIEW }
                            })];
                    }
                    catch (_b) {
                        try {
                            return [2 /*return*/, getAnalytics(app)];
                        }
                        catch (_c) {
                            return [2 /*return*/, null];
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
}
